import { ParamDict, ParamDictToProps } from "@utils/params";

export const G = 24;

//#region GraphParams

export const GraphParams = {
  "svg/width": { type: "int", value: 8 * 24 },
  "svg/height": { type: "int", value: 18 },
  "svg/pad": { type: "int", value: 2 },
} satisfies ParamDict;
export type GraphParams = typeof GraphParams;

export const GraphOptsDefaults = ParamDictToProps(GraphParams);
export type GraphOpts = typeof GraphOptsDefaults;

//#endregion GraphParams
